<template>
  <div class="yunxiao teacher audition-add" data-test="audition-add">
    <div class="main-section">
      <van-field
        readonly
        clickable
        label="选择学员"
        :right-icon="disableChooseStudent? '' : 'arrow'"
        input-align="right"
        @click.stop="toChoiceStudent()"
      >
        <template #input>
          <div v-if="choosedStudent && choosedStudent.id" class="l1 van-ellipsis">
            {{ choosedStudent.name }}
          </div>
          <div v-else class="g5">请选择</div>
        </template>
      </van-field>

      <van-field
        readonly
        clickable
        label="试听课次"
        :right-icon="disableChooseArrange? '' : 'arrow'"
        input-align="right"
        @click="selectArrange"
      >
        <template #input>
          <div v-if="arrange && arrange.length">
            <div class="l1">已选{{ arrange.length }}节课</div>
          </div>
          <div v-else class="g5">请选择</div>
        </template>
      </van-field>

      <van-field
        v-model="remark"
        rows="5"
        type="textarea"
        maxlength="500"
        placeholder="请输入试听备注，仅本机构老师可见"
        show-word-limit
      />
    </div>
    <pageFooterBtn  @click="submit(false)" :loading="submiting" btnText="确定"  loading-text="提交中..."/>


      <van-dialog v-model="showDialog" title="提示" :showConfirmButton="true" v-if="dialogData">
        <div class="dialog">
          <div class="title">学员已存在以下课次中，请选择其他课次试听：</div>
          <div class="line" v-for="item in dialogData" :key="item.id">
             {{ item.startTime | formatDatetime("MM月dd日") }}&nbsp;{{ item.startTime | formatDatetime("hh:mm") }}-{{ item.endTime | formatDatetime("hh:mm") }}
             <span v-if="item.coursePlanType === 1">{{ item.curriculumName }}</span> 
             <span v-else>{{ item.className }}</span>
          </div>
        </div>
    </van-dialog>
  </div>
</template>

<script>
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";

export default {
  name: 'auditionAdd',
  components: {
    pageFooterBtn,
  },
  data () {
    return {
      pageTitle: '安排试听',
      // 选中的学生
      choosedStudent: null,
      // 选中的排课
      arrange: null,
      submiting: false,
      disableChooseStudent: false,
      disableChooseArrange: false,
      remark: '',
      showDialog: false,
      dialogData: null,
    }
  },
  methods: {
    // 选择学员
    async toChoiceStudent () {
      if (this.disableChooseStudent) return false;
      let res = await app.x3.side.xsStudent({
        id: this.choosedStudent && this.choosedStudent.id,        
        params:{
          campusIds: [app.teacher.campusId],
          campusList: [app.teacher.campus],
        },
        config: {
          enableAdd: true,          
          // enableIntentionStatus: true,
        },
      });
      
      this.choosedStudent = Object.assign({}, res);
    },
    // 跳转到选择排课页面
    selectArrange () {
      if (this.disableChooseArrange) {
        return false;
      }
      // 使用localStorage写入选中班级，用于选择页面回显选中
      app.ls.setStorage('choosed-arrange-ids', (this.arrange||[]).map(v=>v.id));
      this.$router.push('/auditionPickerArrange');
    },
    submit (checkClassStudentNum) {
      let { choosedStudent, arrange} = this;
      if (!choosedStudent || !choosedStudent.id) {
        this.$toast('请选择学员');
        return false;
      }
      if (!arrange || !arrange.length) {
        this.$toast('请至少选择一节排课');
        return false;
      }
      let params = {
        teacherId: app.teacher.user.id,
        // 试听记录会是一个数组
        courseArrangeList: [...arrange],
        studentId: choosedStudent.id,
        remark: this.remark,
        checkClassStudentNum: !checkClassStudentNum
      }
      if (this.$vxRoute.query && this.$vxRoute.query.cludId) {
        params.intentionClueId = this.$vxRoute.query.cludId;
      }
      this.submiting = true;
      this.showLoading();
      this.$api.auditionAdd(params)
        .then((res)=>{
          if (res.code === 200) {
            this.$toast.success('安排试听成功');
            let emitName = this.$route.query.name ? 'add-clue-audition-success' : 'refresh-audition-list';
            app.vue.$emit(emitName);
            app.vue.$emit('refresh-arrange-students');
            this.$router.back();
          } else if (res.code === 830000033) {
            this.showDialog = true;
            this.dialogData = res.data.studentAlreadyInCourseArrangeList;
          } else if (res.code === 830000043) {
            this.$dialog
            .confirm({
              title: '提示',
              message: '学员已满，是否确认继续添加学员',
              confirmButtonText: '继续添加',
              cancelButtonText: '取消',
              confirmButtonColor: 'var(--c1)',
            }).then(res => {
              this.submit(true)
            })
          }
          this.submiting = false;
        })
        .catch(err=>{
          console.log(err);
          this.submiting = false;
        })
    }
  },
  created () {
    let { name, id } = this.$route.query;
    if (name && id) {
      this.choosedStudent = { name, id};
      this.disableChooseStudent = true;
    }
    // 排课确认事件响应，获取选中的排课
    this.$onBus("picker-arrange-confirmed", ({choosedList}) => {
      this.arrange = choosedList
    })
    if (this.$route.params && this.$route.params.choosedList){
      this.arrange = this.$route.params.choosedList
      this.disableChooseArrange = true;
    }
    if (this.$route.params && this.$route.params.disableChooseArrange){
      this.disableChooseArrange = true
    }
  },
}
</script>

<style lang="scss" scoped>
.yunxiao.teacher.audition-add{
  display: flex;
  flex-direction: column;
  .main-section{
    padding-bottom: calc(var(--gap) * 12);
    flex: 1;
    overflow-y: auto;
    .g5{
      color: var(--g5);
    }
  }
  .l1{
    word-break: break-all;
  }
  ::v-deep .van-field__value{
    overflow: hidden;
  }
  .dialog {
    padding: 0 16px;
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
    color: var(--g8);
    .title {
      margin-top: 10px;
      margin-bottom: 8px;
    }
    .line {
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      color: var(--g6);
      margin-bottom: 4px;
    }
  }
}
</style>

<!-- 试听学员-可多选学员版本 -->
<!-- <template>
  <div class="yunxiao teacher audition-add" data-test="audition-add">
    <div class="main-section">
      <van-field
        readonly
        clickable
        label="选择学员"
        :right-icon="disableChooseStudent? '' : 'arrow'"
        input-align="right"
        @click.stop="toChoiceStudent()"
      >
        <template #input>
          <div v-if="choosedStudent.length > 0" class="l1 van-ellipsis">
            {{ studentText }}
          </div>
          <div v-else class="g5">请选择</div>
        </template>
      </van-field>

      <van-field
        readonly
        clickable
        label="试听课次"
        :right-icon="disableChooseArrange?'' : 'arrow'"
        input-align="right"
        @click="selectArrange"
      >
        <template #input>
          <div v-if="arrange && arrange.length">
            <div class="l1">已选{{ arrange.length }}节课</div>
          </div>
          <div v-else class="g5">请选择</div>
        </template>
      </van-field>

      <van-field
        v-model="remark"
        rows="5"
        type="textarea"
        maxlength="500"
        placeholder="请输入试听备注，仅本机构老师可见"
        show-word-limit
      />
    </div>
    <pageFooterBtn  @click="submit" :loading="submiting" btnText="确定"  loading-text="提交中..."/>


      <van-dialog v-model="showDialog" title="提示" :showConfirmButton="true" v-if="dialogData">
        <div class="dialog">
          <div class="title">学员已存在以下课次中，请选择其他课次试听：</div>
          <div class="line" v-for="item in dialogData" :key="item.id">
             {{ item.startTime | formatDatetime("MM月dd日") }}&nbsp;{{ item.startTime | formatDatetime("hh:mm") }}-{{ item.endTime | formatDatetime("hh:mm") }}
             <span v-if="item.coursePlanType === 1">{{ item.curriculumName }}</span> 
             <span v-else>{{ item.className }}</span>
          </div>
        </div>
    </van-dialog>
  </div>
</template>

<script>
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";

export default {
  name: 'auditionAdd',
  components: {
    pageFooterBtn,
  },
  data () {
    return {
      pageTitle: '安排试听',
      // 选中的学生
      choosedStudent: [],
      choosedStudentList: [],
      // 选中的排课
      arrange: null,
      submiting: false,
      disableChooseStudent: false,
      disableChooseArrange: false,
      remark: '',
      showDialog: false,
      dialogData: null,
    }
  },
  computed: {
    studentText: function() {
      let tcs = this.choosedStudent,
        text = '';
      if (tcs.length == 1) {
        text = tcs[0].name;
      } else if (tcs.length > 1) {
        text = `${tcs.length}个学员`;
      }
      return text;
    },
  },
  methods: {
    // 选择学员
    async toChoiceStudent () {
      if (this.disableChooseStudent) return false;
      let res = await app.x3.side.xsStudent({
        // id: this.choosedStudent && this.choosedStudent.id, 
        ids: this.choosedStudent,
        list: this.choosedStudentList,       
        params:{
          campusIds: [app.teacher.campusId],
          campusList: [app.teacher.campus],
        },
        config: {
          enableAdd: true,          
          // enableIntentionStatus: true,
        },
      });
      
      // this.choosedStudent = Object.assign({}, res);
      this.choosedStudent = res.ids;
      this.choosedStudentList = res.list;
    },
    // 跳转到选择排课页面
    selectArrange () {
      if (this.disableChooseArrange) return false;
      // 使用localStorage写入选中班级，用于选择页面回显选中
      app.ls.setStorage('choosed-arrange-ids', (this.arrange||[]).map(v=>v.id));
      this.$router.push('/auditionPickerArrange');
    },
    submit () {
      let { choosedStudent, arrange} = this;
      if (choosedStudent.length == 0) {
        this.$toast('请选择学员');
        return false;
      }
      if (!arrange || !arrange.length) {
        this.$toast('请至少选择一节排课');
        return false;
      }
      let params = {
        teacherId: app.teacher.user.id,
        // 试听记录会是一个数组
        courseArrangeList: [...arrange],
        studentIds: choosedStudent,
        remark: this.remark
      }
      if (this.$vxRoute.query && this.$vxRoute.query.cludId) {
        params.intentionClueId = this.$vxRoute.query.cludId;
      }
      this.submiting = true;
      this.showLoading();
      this.$api.auditionAdd(params)
        .then((res)=>{
          if (res.code === 200) {
            this.$toast.success('安排试听成功');
            let emitName = this.$route.query.name ? 'add-clue-audition-success' : 'refresh-audition-list';
            app.vue.$emit(emitName);
            app.vue.$emit('refresh-arrange-students');
            this.$router.back();
          } else if (res.code === 830000033) {
            this.showDialog = true;
            this.dialogData = res.data.studentAlreadyInCourseArrangeList;
          }
          this.submiting = false;
        })
        .catch(err=>{
          console.log(err);
          this.submiting = false;
        })
    }
  },
  created () {
    let { name, id } = this.$route.query;
    if (name && id) {
      // this.choosedStudent = { name, id};
      this.choosedStudent = [id];
      this.choosedStudentList = [{
        id,
        name
      }]
      this.disableChooseStudent = true;
    }
    // 排课确认事件响应，获取选中的排课
    this.$onBus("picker-arrange-confirmed", ({choosedList}) => {
      this.arrange = choosedList
    })
    if (this.$route.params && this.$route.params.choosedList){
      this.arrange = this.$route.params.choosedList
      this.disableChooseArrange = true;
    }
  },
}
</script>

<style lang="scss" scoped>
.yunxiao.teacher.audition-add{
  display: flex;
  flex-direction: column;
  .main-section{
    padding-bottom: calc(var(--gap) * 12);
    flex: 1;
    overflow-y: auto;
    .g5{
      color: var(--g5);
    }
  }
  .l1{
    word-break: break-all;
  }
  ::v-deep .van-field__value{
    overflow: hidden;
  }
  .dialog {
    padding: 0 16px;
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
    color: var(--g8);
    .title {
      margin-top: 10px;
      margin-bottom: 8px;
    }
    .line {
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      color: var(--g6);
      margin-bottom: 4px;
    }
  }
}
</style> -->